// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"80f85cb2","721":"3ce9f239","760":"e17e1aff","769":"bc4eff7f","779":"40558790","787":"d4aba7ab","947":"fbeb8b46"}[chunkId] + ".chunk.js";
};